export const TIMEOUT_SEC = 10; //seconds
export const SHOWCASE_SEC = 3; //seconds
